import { Injectable } from "@angular/core";
import {
  MyHttpService,
  LoaderService,
} from "potscommonui/src/app/component-library/index";
import { HttpClient } from "@angular/common/http";
import { DataService } from "./data.service";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class GuestService extends MyHttpService {
  // for autentication
  private exitSurveyUrl = "../lsrsdp/exit-survey";
  private contactUsUrl = "../lsrsdp/contact-us";
  private metadataUrl = "../lsrsdp/metadata/";
  private preSignupUrl = "../lsrsdp/pre-signup";
  private phoneCodeUrl = "../lsrsdp/country-phonecode-mapping";

  private recaptchav2URL = "../recaptchav2";
  private landingPageHitUrl = "../lsrsdp/landing";
  private supportedOsUrl = "../lsrsdp/supported-os";
  private sendAuthenticationOtpUrl = "../lsrsdp/send-authentication-otp";

  private _username: string;
  private _password: string;
  private headersCustom; // ... Set content type to JSON
  set username(val: string) {
    this._username = val;
  }
  set password(val: string) {
    this._password = val;
  }

  get username(): string {
    return this._username;
  }
  get password(): string {
    return this._password;
  }

  constructor(
    http: HttpClient,
    loaderService: LoaderService,
    private dataService: DataService
  ) {
    super(http, loaderService);
  }

  metadata(countryCode) {
    return this.performAjaxCall(
      this.metadataUrl + countryCode,
      "GET",
      {},
      false
    );
  }
  preSignup(requestBody, loaderReq) {
    return this.performAjaxCall(
      this.preSignupUrl,
      "POST",
      requestBody,
      loaderReq
    );
  }
  exitSurvey(requestBody, loaderReq) {
    return this.performAjaxCall(
      this.exitSurveyUrl,
      "POST",
      requestBody,
      loaderReq
    );
  }
  contactUs(requestBody, loaderReq) {
    return this.performAjaxCall(
      this.contactUsUrl,
      "POST",
      requestBody,
      loaderReq
    );
  }
  fetchCountryCodes(requestBody) {
    return this.performAjaxCall(this.phoneCodeUrl, "POST", requestBody, false);
  }
  recaptchav2(requestBody) {
    return this.performAjaxCall(
      this.recaptchav2URL,
      "POST",
      requestBody,
      false
    );
  }
  putLandingPageHit(requestBody) {
    return this.performAjaxCall(
      this.landingPageHitUrl,
      "POST",
      requestBody,
      false
    );
  }
  supportedOS() {
    return this.performAjaxCall(this.supportedOsUrl, "GET", {}, false);
  }
  preSignupInterviewer(requestBody, loaderReq) {
    return this.performAjaxCall(
      this.preSignupUrl,
      "PUT",
      requestBody,
      loaderReq
    );
  }

  contactUsSignedin(requestBody, loaderReq) {
    return this.performAjaxCall(
      this.contactUsUrl,
      "PUT",
      requestBody,
      loaderReq
    );
  }

  sendAuthenticationOtp(requestBody): Observable<any> {
    return this.performAjaxCall(
      this.sendAuthenticationOtpUrl,
      "POST",
      requestBody,
      true
    );
  }
}
